import { mockUsersData, IReportData } from "@/entities";

export const mockReportData = (): IReportData[] => [
  {
    id: 1,
    filename: "2022_11_25__12_15_54_book.xlsx",
    status: "UPLOADED",
    requestDate: "2021-05-04T08:04:27.922+00:00",
    reportDate: "2021-05-04T08:04:27.922+00:00",
    expirationDate: "2021-05-11T08:04:27.922+00:00",
    user: mockUsersData()[0],
  },
  {
    id: 2,
    filename: "2022_11_25__12_15_54_book.xlsx",
    status: "UPLOADED",
    requestDate: "2021-05-04T08:04:27.922+00:00",
    reportDate: "2021-05-04T08:04:27.922+00:00",
    expirationDate: "2021-05-11T08:04:27.922+00:00",
    user: mockUsersData()[1],
  },
];
